'use strict';

function navigationFunction(g) {
  var $burger = $(".burger");
  var $mainNav = $(".nav-main");
  var $mainMenuHasChildren = $mainNav.find('li.menu-item-has-children');
  var $mainNavHeight = $mainNav.innerHeight();
  var $sticky = $mainNav.offset();

  function updateStickyHeightActivation() {
    $sticky = $mainNav.offset();
  }

  function mainMobileNav() {
    $burger.on("click", function(e) {
      e.preventDefault();
      g.body.toggleClass('main-nav-opened');
      $mainMenuHasChildren.removeClass("opened");
      $mainNav.animate({scrollTop: 0}, 50);
    });

    $mainMenuHasChildren.find("> a").on("click", function(e) {
      if(screen.width < 992) {
        e.preventDefault();
      }
      $(this).closest("li").toggleClass("opened");
    });
  };

  function stickyMainNav() {
    if ($(window).scrollTop() > $sticky.top) {
      g.body.addClass("main-nav-sticky");
    } else {
      g.body.removeClass("main-nav-sticky");
    }
  }

  function init() {
    mainMobileNav();
    stickyMainNav();
    updateStickyHeightActivation();

    $(window).on("scroll", stickyMainNav);
    $(window).on("resize", updateStickyHeightActivation);
  }

  init();
}
